<!--
 * Path: src/core/components/common/BaseTabbar.vue
 * Task: Standardized container for application tabs, supporting both horizontal and vertical layouts.
-->
<template>
  <v-tabs
    v-model="modelValue"
    :color="color"
    :bg-color="bgColor"
    :density="density"
    :direction="direction"
    :grow="direction === 'horizontal'"
    class="base-tabbar"
    :class="{ 'w-100 horizontal-tabs': direction === 'horizontal', 'h-100 vertical-tabs': direction === 'vertical' }"
  >
    <slot></slot>
  </v-tabs>
</template>

<script setup lang="ts">
/**
 * Path: src/core/components/common/BaseTabbar.vue
 * Task: Setup layout configurations for the generic tab bar component with direction support.
 */
interface Props {
  color?: string;
  bgColor?: string;
  density?: 'default' | 'comfortable' | 'compact';
  direction?: 'horizontal' | 'vertical';
}

withDefaults(defineProps<Props>(), {
  color: 'primary',
  bgColor: 'transparent',
  density: 'default',
  direction: 'horizontal'
});

const modelValue = defineModel<any>();
</script>

<style scoped>
.horizontal-tabs {
  border-bottom: 1px solid rgba(var(--v-border-color), var(--v-border-opacity)) !important;
}

.vertical-tabs {
  height: 100% !important;
}
</style>
